import * as Setting from "../conf/Setting";

export function getConfigs(owner) {
  return fetch(`${Setting.ServerUrl}/api/get-account-activation-configs?owner=${owner}`, {
    method: "GET",
    credentials: "include",
  }).then(res => res.json());
}

// 获取单个密码策略
export function getConfig(owner, uid) {
  return fetch(`${Setting.ServerUrl}/api/get-account-activationConfig?id=${owner}/${uid}`, {
    method: "GET",
    credentials: "include",
  }).then(res => res.json());
}

export function addConfig(config) {
  const newConfig = Setting.deepCopy(config);
  return fetch(`${Setting.ServerUrl}/api/add-account-activation-config`, {
    method: "POST",
    credentials: "include",
    body: JSON.stringify(newConfig),
  }).then(res => res.json());
}

export function updateConfig(config, owner, uid) {
  const newConfig = Setting.deepCopy(config);
  return fetch(`${Setting.ServerUrl}/api/update-account-activation-config?id=${owner}/${uid}`, {
    method: "POST",
    credentials: "include",
    body: JSON.stringify(newConfig),
  }).then(res => res.json());
}

export function deleteConfig(config) {
  const newConfig = Setting.deepCopy(config);
  return fetch(`${Setting.ServerUrl}/api/delete-account-activation-config`, {
    method: "POST",
    credentials: "include",
    body: JSON.stringify(newConfig),
  }).then(res => res.json());
}
